<div class="control">
  <span>{{ label }}</span>
  <div class="card flex justify-content-center align-items-center gap-5">
    <p-slider
      class="w-full"
      [step]="1"
      [min]="0"
      [max]="10"
      [(ngModel)]="model[modelKey]"
      [formControl]="control"
    />
    <p-inputNumber
      [(ngModel)]="model[modelKey]"
      [showButtons]="true"
      [formControl]="control"
      [min]="0"
      [max]="10"
      buttonLayout="horizontal"
      inputId="lastTouch"
      spinnerMode="horizontal"
      [step]="1"
      decrementButtonClass="p-button-secondary"
      incrementButtonClass="p-button-secondary"
    />
  </div>
</div>
